var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!../../node_modules/vue-style-loader/index.js!css-loader?{\"autoprefixer\":false,\"sourceMap\":false,\"minimize\":true}!../../node_modules/ream/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-2ce15f24\",\"scoped\":false,\"hasInlineConfig\":true}!../../node_modules/ream/node_modules/vue-loader/lib/selector?type=styles&index=0!./x-circle.vue")
}
var Component = require("!../../node_modules/ream/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!../../node_modules/babel-loader/lib/index.js?{\"babelrc\":true,\"cacheDirectory\":true}!../../node_modules/ream/node_modules/vue-loader/lib/selector?type=script&index=0!./x-circle.vue"),
  /* template */
  require("!!../../node_modules/ream/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2ce15f24\",\"preserveWhitespace\":false}!../../node_modules/ream/node_modules/vue-loader/lib/selector?type=template&index=0!./x-circle.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/en/components/x-circle.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] x-circle.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2ce15f24", Component.options)
  } else {
    hotAPI.reload("data-v-2ce15f24", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./en/components/x-circle.vue
// module id = 379
// module chunks = 99